module.exports = __webpack_public_path__ + "img/durocher_svg_V2.938ef911.svg";